app.service('accountConfig', function(pageConfig) {
	function getData() {
		return pageConfig.getData('account');
	}
	
	return {
		getData: getData
	};
});